import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface MakeMappingCrsViewModel {
  crsMakeCode?: string;
  crsMakeDescription?: string;
}

export interface MakeMappingViewModel {
  dataProviderId: number;
  dataProviderName: string;
  dataProviderMakeId?: number;
  dataProviderMakeDescription?: string;
  isSupported?: boolean;
  crsMakes: MakeMappingCrsViewModel[];
}

export interface MakeMappingModel {
  dataProviderId: number;
  dataProviderMakeId?: number;
  dataProviderMakeDescription?: string;
  isSupported?: boolean;
  crsMakeCodes: string[];
}

class CreateMakeMappingRequest {
  makeMapping?: MakeMappingModel;
}

class UpdateMakeMappingRequest {
  dataProviderId?: number;
  dataProviderMakeId?: number;
  dataProviderMakeDescription?: string;
  makeMapping?: MakeMappingModel;
}

class GetMakeMappingsRequest {}

class GetMakeMappingsResponse {
  makeMappings?: MakeMappingViewModel[];
}

class DeleteMakeMappingRequest {
  dataProviderId?: number;
  dataProviderMakeId?: number;
  dataProviderMakeDescription?: string;
}

export const makeMappingAPI = {
  async createMakeMapping(makeMapping: MakeMappingModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateMakeMapping", {
      makeMapping: makeMapping,
    } as CreateMakeMappingRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "MakeMapping");

    return response;
  },

  async updateMakeMapping(
    dataProviderId: number,
    dataProviderMakeId: number | undefined,
    dataProviderMakeDescription: string | undefined,
    makeMapping: MakeMappingModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateMakeMapping", {
      dataProviderId: dataProviderId,
      dataProviderMakeId: dataProviderMakeId,
      dataProviderMakeDescription:
        dataProviderMakeDescription?.length === 0
          ? undefined
          : dataProviderMakeDescription,
      isSupported: makeMapping.isSupported,
      makeMapping: makeMapping,
    } as UpdateMakeMappingRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "MakeMapping");

    return response;
  },

  async getMakeMappings(): Promise<Result<MakeMappingViewModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetMakeMappingsResponse>(
        "GetMakeMappings",
        new GetMakeMappingsRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.makeMappings ?? [] };
    }

    return response;
  },

  async deleteMakeMapping(
    dataProviderId: number,
    dataProviderMakeId?: number,
    dataProviderMakeDescription?: string,
  ) {
    let response = await backendApi.sendAsync("DeleteMakeMapping", {
      dataProviderId: dataProviderId,
      dataProviderMakeId: dataProviderMakeId,
      dataProviderMakeDescription: dataProviderMakeDescription,
    } as DeleteMakeMappingRequest);

    return response;
  },
};
